module.exports = __webpack_public_path__ + "static/media/arrow-circle-up.cba47223.svg";